export default __webpack_public_path__ + "static/media/it.476d8f50.svg";